/**
 * Typesafe object properties pick.
 *
 * @param obj Object to pick the properties from
 * @param keys Property names
 */
export function pick<T, K extends keyof T>(obj: T, ...keys: K[]): Pick<T, K> {
  const ret: any = {};
  keys.forEach((key) => {
    ret[key] = obj[key];
  });
  return ret;
}
